import {remoteRoutingModule} from "./remoteRoutingModule";

class NlgRemoteRoutingOverviewDashboardController {
    dashboardConfiguration = {dashboardSourceId: "gcpOverview"};
}

remoteRoutingModule.directive("nlgRemoteRoutingOverviewDashboard", [function () {
    return {
        restrict: "E",
        scope: {},
        controller: NlgRemoteRoutingOverviewDashboardController,
        controllerAs: "ctrl",
        template: `<dashboard config="ctrl.dashboardConfiguration" domain="gcp-resource"></dashboard>`
    }
}])